import { createBrowserHistory as createHistory, History } from 'history'
import { INV_SUB_PATH } from '@inv/utils/es/constants/url'
import bridge from '@helper/common/bridge'
import Stack from './stack'
import { safeGet } from '@inv/utils/es/common'
import { PopWebViewParams, WebBridgeCommand } from '@shopee/web-bridge-sdk'

const history = createHistory({
  basename: `${INV_SUB_PATH}/`
}) as SHistory.IHistory
const {
  push,
  replace,
  go,
  location: { pathname, state }
} = history

const stack = new Stack()
stack.push(pathname, state)

/**
 * transfer push({ pathname, state }) to
 * push(pathname, state)
 * place it to the outermost of decorators
 */
const parseParamsDecorate =
  func =>
  (path, state = {}) => {
    if (typeof path === 'object') {
      state = path.state || {}
      path = path.pathname
    }
    func.call(history, path, state)
  }

const addFromDecorate = func => {
  return (path, state = {}) => {
    const { pathname, search, key, hash } = history.location
    func.call(history, path, {
      ...state,
      from: { pathname, search, key, hash }
    })
  }
}

const addParallelFromDecorate = func => {
  return (path, state = {}) => {
    const { state: curState } = history.location
    func.call(history, path, {
      ...state,
      parallelFrom: safeGet(curState, 'from', {})
    })
  }
}

const bridgeDecorate = func => {
  return (path, state: History.LocationState = {}) => {
    const { isBridge, popSelf } = state as any
    if (isBridge) {
      if (path.startsWith('rn')) {
        bridge.call(WebBridgeCommand.NavigateAppPath, { path, popSelf })
      } else {
        bridge.call(WebBridgeCommand.Navigate, {
          url: path,
          popSelf
        })
      }
    } else {
      func.call(history, path, state)
    }
  }
}

history.push = parseParamsDecorate(
  bridgeDecorate(
    addFromDecorate((path, state) => {
      stack.push(path, state)
      push(path, state)
    })
  )
)

history.replace = parseParamsDecorate(
  addParallelFromDecorate(
    addFromDecorate((path, state) => {
      stack.replace(path, state)
      replace(path, state)
    })
  )
)

history.goBack = (params: PopWebViewParams) => {
  if (stack.topIndex() === 0) {
    bridge.call(WebBridgeCommand.PopWebView, params)
  } else {
    stack.go(-1)
    go(-1)
  }
}

/**
 * 回退到最近的匹配pathName的页面
 * @param pathName target pathName to return
 */
history.goBackTo = (pathNames: string[], notFoundCallBack: Function) => {
  if (stack.topIndex() === 0) {
    bridge.call(WebBridgeCommand.PopWebView)
  } else {
    const targetPathNameIndex = safeGet(stack, 's1', [])
      .slice()
      .reverse()
      .slice(1)
      .findIndex(item => pathNames.includes(item.pathname))
    if (targetPathNameIndex >= 0) {
      const step = targetPathNameIndex + 1
      stack.go(-step)
      go(-step)
    } else {
      notFoundCallBack && notFoundCallBack()
    }
  }
}

// 这个方法危险，不推荐使用，推荐使用每个route组件自带的 location.state.from.pathname 判断
history.isFromPathName = (pathname: string) => {
  const historyStack = safeGet(stack, 'records', [])
  const lastPageRecord = historyStack[historyStack.length - 1]
  const lastPageUrl = safeGet(lastPageRecord, 'current.pathname', '')
  const lastPathName = lastPageUrl.split('?')[0]
  return lastPathName === pathname
}

history.goForward = () => {
  stack.go(1)
  go(1)
}

history.go = step => {
  if (step < 0 && stack.topIndex() < Math.abs(step)) {
    bridge.call(WebBridgeCommand.PopWebView)
  } else {
    stack.go(step)
    go(step)
  }
}

// could use this to debug in PC
// window.onpopstate = e => {
//   stack.goBack()
// }

history.stack = stack
export default history
